<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon color="primary text--darken-2" @click="openCommentModal">
          <v-icon>
            mdi-comment-edit-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{commentsCounter}} comments</span>
    </v-tooltip>
    <!--dialog-->
    <show-comments
      ref="commentsDialog"
      :profile-id="profileId"
      @comment-added="updateCommentsCounter($event.commentsCount)"
    >
    </show-comments>

  </div>
</template>

<script>
  import ShowComments from "../../Dialogs/Profiles/showComments";

  export default {
    components: {ShowComments},
    props: ['commentsCount', 'profileId'],
    name: "commentProfile",
    data: () => ({
      commentsCounter: 0
    }),
    methods: {
      openCommentModal() {
        //this.$ga.event('', 'open modal', 'profile changes modal');
        this.$refs.commentsDialog.openModal();
      },
      updateCommentsCounter(counter) {
        this.commentsCounter = counter;
      }
    },
    mounted() {
      this.commentsCounter = this.commentsCount
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Buttons/Profiles/commentProfile.vue